$('.modal__toggle-open').click(function() {
  $('main').addClass('search_overlay_bg');
  $('body').addClass('overflow-hidden-body');
});
$('.search-modal__close-button').click(function() {
  $('main').removeClass('search_overlay_bg');
  $('body').removeClass('overflow-hidden-body');
});
$('body').on('click', '.search_overlay_bg', function() {
  $('.search-modal__close-button').trigger('click');
})

jQuery(document).on('click', 'button.boost-pfs-search-btn-close-suggestion', function(event) {
  $("main").removeClass("search_overlay_bg");
  $('body').removeClass('overflow-hidden-body');
});

$(window).on('load resize', function() {
  var swiper = null;

  function initSwiper() {
    if (window.innerWidth <= 1024) {

      swiper = new Swiper(".mySwiper", {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        freeMode: {
          enabled: true,
          sticky: false,
        },
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
        },
      });
    } else {

      if (swiper) {
        //         swiper.destroy();
      }
    }
  }

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper, 200);
  });

  initSwiper();
});

function initSwiper1() {
  swiper1 = new Swiper(".shop_by_age__section .desktop-cont", {
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    spaceBetween: 30,
    loop: false,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      600: {
        spaceBetween: 20,
      },

    }
  })
};

function initSwiper2() {
  swiper2 = new Swiper(".social-block-section .desktop-cont", {
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    spaceBetween: 15,
    loop: false,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      480: {
        spaceBetween: 15,
      },
      600: {
        spaceBetween: 20,
      },
      1200: {
        spaceBetween: 40,
      },
    },
  });
}

$(window).on('load resize', function() {
  var swiper1 = null;
  var swiper2 = null;

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper1, 200);
  });

  initSwiper1();
  initSwiper2();
});

// 
$(window).on('load resize', function() {
  var swiper3 = null;

  function initSwiper3() {
    if (window.innerWidth <= 1024) {

      swiper3 = new Swiper(".brand-collection .slider-mobile-gutter ", {
        slidesPerView: "auto",
        centerInsufficientSlides: true,
        //         spaceBetween: 20,
        loop: false,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          forceToAxis: true
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    } else {

      if (swiper3) {
        //         swiper3.destroy();
      }
    }
  }
  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper3, 200);
  });

  initSwiper3();
});

$(window).on('load resize', function() {
  var swiper5 = null;

  function initSwiper5() {
    swiper5 = new Swiper(".swiper.slider--on--main", {
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      spaceBetween: 20,
      loop: false,
      freeMode: {
        enabled: true,
        sticky: true,
      },
      mousewheel: {
        forceToAxis: true
      },
      /*
      slidesPerView: 6,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 3.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 5.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 6.5,
          spaceBetween: 20,
        },
        1560: {
          slidesPerView:10,
          spaceBetween: 20,
        }
      },
      */
    });
  }
  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper5, 200);
  });

  initSwiper5();
});

$(window).on('load resize', function() {
  var swiper6 = null;

  jQuery('.zoom').each(function() {
    if ($(this).find('.zoomImg').length < 1) {
      $(this).zoom();
    }
  });

  if (window.innerWidth <= 993) {
    $('.zoom').trigger('zoom.destroy');
  }

  setTimeout(function() {
    jQuery('.zoom').each(function() {
      var zoomImgwidth = $(this).find('.zoomImg').width();
      var originalImagewidth = $(this).find('.image-zoom').width();
      if (zoomImgwidth < originalImagewidth) {
        $('.zoom').trigger('zoom.destroy');
      }
    });
  }, 500);

  function initSwiper6() {
    if ($(window).width() <= 993) {
      swiper6 = new Swiper(".product_swiper_mobile ", {
        slidesPerView: 1,
        spaceBetween: 50,
        cache: false,
        lazy: true,
        loop: false,
        /*
         pagination: {
           el: ".swiper-pagination",
           type: "progressbar",
         },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        */
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        }

      });

    } else {

    }
  }
  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper6, 200);
  });

  initSwiper6();
});

// var isIOS = /iPad|iPod/.test(navigator.userAgent) && !window.MSStream;
// if (isIOS) {

//   $('.view-all-brands').on( 'click', function(e){
//     $('html, body').animate({
//       scrollTop:1350
//     }, 1200)

//   });
// }
// var isMobile = false; //initiate as false
// // device detection
// if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
//    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
//   isMobile = true;
//   $('.view-all-brands').on( 'click', function(e){
//     $('html, body').animate({
//       scrollTop:600
//     }, 1200)

//   });

// }

$(document).ready(function() {
  $('.view-all-brands').on('click', function(event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr("href")).offset().top
    }, 500)

  });
  $(".first-level_link").click(function() {
    $(".menu_bottom_sec").hide();
  });
  $(".menu-drawer__inner-submenu .second_tier > .custom_drawer_back").click(function() {
    $(".menu_bottom_sec").show();
  });
  $(".header_main_drawer svg.menu__drawer_open").click(function() {});
  $(".header_main_drawer .menu__drawer_close").click(function() {
    $(".menu_bottom_sec").show();
  });
  //    image-text-carousel
  $(".image-slider--on--main").slideUp();
  $(".show_toggle_text").click(function() {
    $(".image-slider--on--main").slideToggle();
  });
  // search input clear
  $(".clear__input-search").click(function() {
    $(".search__input").value = '';
    $(".search__input").val('').empty();
  });

  //   gift textarea empty
  $(".note_drawer_class .drawer__close").click(function() {
    $("#Cart-note").val('').empty();
  });

  window.onload = function() {
    $("#Cart-note").val('').empty();
  }

  $(".cancel-btn").click(function() {
    $("#Cart-note").val('').empty();
  });

  $(".boost-pfs-search-btn-close-suggestion").click(function() {
    $(".boost-pfs-search-box").val('').empty();
  });

  //   product page js
  $(document).on('click', '.variant-select input', function(e) {
    var abc = $(this).val();
    $('.swatch-size-label').text(abc);
    //alert(abc);
  });
  //   $(document.body).on('click', '.swym-add-to-wishlist', function (e) {

  //     $(".added_class").css("display","block");
  //   });
  //   $(".slider--on--main").slideUp();
  $(".show_toggle").click(function() {
    //     $(this).toggleClass( "active" );
    $(".slider--on--main").addClass('activeSlide');
    //         $(".slider--on--main").slideToggle('slow');
    $(this).hide();
    $(".hide_toggle").show();
  });
  $(".hide_toggle").click(function() {
    $(this).hide();
    $(".show_toggle").show();
    $(".slider--on--main").removeClass('activeSlide');
  })
  $('.accordion').on('click', function() {
    $('.accordion').find('.description_inner').stop().slideUp(600);
    $(this).closest('.accordion').find('.description_inner').stop().slideToggle(600);
    $(this).toggleClass('active');
    $('.accordion').not($(this)).removeClass('active');
  });

  $('.content_tab_switch').on('click', function() {
    this.classList.toggle("active");
  });
  $('.content_tab_switch li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('.content_tab_switch li').click(function() {
    $('.content_tab_switch li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    // $('.content__Footer').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  setTimeout(function() {
    $("#smile-ui-lite-container").css("zIndex", "1");
  }, 3000);

  $('.icon-custom-grid').on('click', function() {
    this.classList.toggle("active");
    $(".listing_button").removeClass('active');
    $(".grid_button").addClass('active');
    $(".grid__item").removeClass('grid__item_1');
    $(".grid__item").addClass('grid__item_2');
    $("#main-collection-product-grid").removeClass('remove-marginMinus');
    $(".boost-pfs-search-panel-product-show .boost-pfs-filter-right .boost-pfs-filter-products").removeClass('remove-marginMinus');

  });

  $('.icon-custom-listing').on('click', function() {
    $(".grid_button").removeClass('active');
    $(".listing_button").addClass('active');
    $(".grid__item").addClass('grid__item_1');
    $(".grid__item").removeClass('grid__item_2');
    $("#main-collection-product-grid").addClass('remove-marginMinus');
    $(".boost-pfs-search-panel-product-show .boost-pfs-filter-right .boost-pfs-filter-products").addClass('remove-marginMinus');
  });

  //   on cart page display table
  $(".listed--main_menu").hover(function() {
    $("cart-items.page-width").css("zIndex", "-1");
  }, function() {
    $("cart-items.page-width").css("zIndex", "1");
  });
  if ($("#SortList li a").attr("href") == window.location.href) {
    $("#SortList li").attr("class", "sort_list active");
  } else {
    $("#SortList li").attr("class", "sort_list");
  }

  /*$(document).on('click', '#CollectionProductGrid .pagination__list li a', function(event) {
    console.log('test');
    var jQueryanchor = $(this);
    $('html, body').stop().animate({
      scrollTop: $(jQueryanchor.attr('href')).offset().top - 400
    }, 1500, 'easeInOutExpo');
    event.preventDefault();
  });*/

  $(".brand-title .accordion_title").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".brand-title .panel")
        .slideUp(200);
      $(".brand-title .accordion_title i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".brand-title .accordion_title i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".brand-title .accordion_title").removeClass("active");
      $(this).addClass("active");
      $(".brand-title .panel").slideUp(200);
      $(this)
        .siblings(".brand-title .panel")
        .slideDown(200);
    }
  });

  $(".accordion_block .toggle").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".accordion_block .inner")
        .slideUp(500);
      $(".accordion_block .toggle i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".accordion_block .toggle i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".accordion_block .toggle").removeClass("active");
      $(this).addClass("active");
      $(".accordion_block .inner").slideUp(500);
      $(this)
        .siblings(".accordion_block .inner")
        .slideDown(500);
    }
  });


});

var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (isIOS) {
  $(".menu-drawer__utility-links.menu_bottom_sec").css('padding-bottom', '10rem');
  $(".menu-drawer__menu.list-menu.child_list-menu").css('padding-bottom', '13rem');
} else {

}

function detectBrowser() {
  if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
    return 'Opera';
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    return 'Chrome';
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    $(".menu-drawer__utility-links.menu_bottom_sec").css('padding-bottom', '10rem');
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    return 'Firefox';
  } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) {
    return 'IE'; //crap
  } else {
    return 'Unknown';
  }
}

//     menu drawer custom js
$(document).ready(function() {
  $('.close_main_menu').on('click', function() {
    /* setTimeout(function(){
      $('details').removeAttr('open');
    }, 500); */

    $(".header__icon--summary").attr("aria-expanded", "false");
    $('#menu-drawer').removeClass('menu_open');
    $('body').removeClass('overflow-hidden-mobile');
    $('body').removeClass('overflow-hidden-tablet');
    $('.menu-drawer-container').removeClass('menu-opening');

  });

  //  Mobile menu drawer overlay 

  $('.menu-drawer-container .header__icon--menu').click(function() {
    $('body').addClass('body_overlay_active');
  });

  $('#menu-drawer .close_main_menu').click(function() {
    setTimeout(function() {
      $('body').removeClass('body_overlay_active');
    }, 200);
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('#menu-drawer').length && !$(event.target).closest('summary.header__icon').length) {
      $('#menu-drawer .close_main_menu').trigger('click');
    }
  });
  var swiper7 = new Swiper(".announcement_bar_slider", {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    effect: 'slide',
    speed: 1000,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    }
  });
  $(".sub_menu_inr a").on("click", function() {
    localStorage.setItem("activeParent", $(this).closest('.listed--main_menu').attr('id'));
  });
  if (localStorage.getItem("activeParent") != undefined) {
    $('.header__inline-menu').find('.listed--main_menu').find('summary > span.header__active-menu-item').removeClass('header__active-menu-item');
    $('.header__inline-menu .listed--main_menu[id="' + localStorage.getItem("activeParent") + '"] summary > span').addClass('header__active-menu-item');
  }

  var loc = location.href;
  loc.replace(/\/$/, "");
  if (loc.indexOf('/collections/') != -1 || loc.indexOf('/products/') != -1) {} else {
    localStorage.removeItem("activeParent");
    $('.header__inline-menu').find('.listed--main_menu').find('summary > span').removeClass('header__active-menu-item');
  }
});

$(window).on('load resize', function() {
  var swiper8 = null;

  function initSwiper8() {
    if (window.innerWidth <= 768) {

      swiper8 = new Swiper(".product__sub_flex", {
        slidesPerView: 2.5,
        spaceBetween: 20,
        centerInsufficientSlides: true,
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
        },
      });
    } else {

      if (swiper8) {
        //         swiper8.destroy();
      }
    }
  }

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper8, 200);
  });

  initSwiper8();
});

$(document).ready(function() {
  //   $('.added_class').html('Item is removed from wishlist ');
  var mediaData = $('.product_swiper_mobile .slider--mobile').attr('media-item');
  if (mediaData == 1) {
    $('.swiper-pagination').hide();
  }

  function initSwiper4() {
    var swiper4 = new Swiper(".sub_collection_de", {
      slidesPerView: 6,
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 30,

        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 30,
        },
      },
    });
    //      Slider.update();
  }

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper4, 200);

  });

  initSwiper4();
  //  Slider.update();

});

// Swiper: swtaches Slider
// $(window).on('load resize', function(){  
//   if($('.custom-collection__List .shop_by_category .swiper-button-next').hasClass('swiper-button-disabled')){
//     $('.custom-collection__List .shop_by_category .swiper-button-next').removeClass('swiper-button-disabled swiper-button-lock');
//   }
//   if($('.sub_collection_de .swiper-button-next').hasClass('swiper-button-disabled')){
//     $('.sub_collection_de .swiper-button-next').removeClass('swiper-button-disabled swiper-button-lock');
//   }
// });

// add for mobile menu

// Bind an event to window.orientationchange that, when the device is turned,
// gets the orientation and displays it to on screen.
// Bind an event to window.orientationchange that, when the device is turned,
// gets the orientation and displays it to on screen.
// window.addEventListener("orientationchange", function() {

//   if ( window.orientation == 0 || window.orientation == 180) {
//     // WHEN IN PORTRAIT MODE
//      $('.cart_drawer_class').removeClass('menu-drawer-landscap');

//   } else {
//     // WHEN IN LANDSCAPE MODE
//    $('.cart_drawer_class').addClass('menu-drawer-landscap');

//   }
// }, false);

// window.addEventListener("load", function() {

//   if ( window.orientation == 0 || window.orientation == 180) {
//     // WHEN IN PORTRAIT MODE
//      $('.cart_drawer_class').removeClass('cart-drawer-landscap');

//   } else {
//     // WHEN IN LANDSCAPE MODE
//    $('.cart_drawer_class').addClass('cart-drawer-landscap');

//   }
// }, false);

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// let removeURL = setInterval(function(){
//   if(typeof Filter == "function"){
//     clearInterval(removeURL);
//     Filter.prototype.afterRender = function(){
//       if(window.location.search.includes('?pf_')) window.history.replaceState(null,null,window.location.pathname);
//     }
//   }
// },500)


jQuery('.form-status.form-status-list.form__message').insertBefore('.contact__button');

// Footer Accordion js
$(window).on('load resize', function() {
  if (window.innerWidth <= 749) {
    // Bind click event for mobile screens
    $(".footer_menu-_blocks.accordion_blocks .toggles").off("click").on("click", function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
          .siblings(".footer_menu-_blocks.accordion_blocks .inners")
          .slideUp(500);
        $(".footer_menu-_blocks.accordion_blocks .toggles i")
          .removeClass("fa-minus")
          .addClass("fa-plus");
      } else {
        $(".footer_menu-_blocks.accordion_blocks .toggles i")
          .removeClass("fa-minus")
          .addClass("fa-plus");
        $(this)
          .find("i")
          .removeClass("fa-plus")
          .addClass("fa-minus");
        $(".footer_menu-_blocks.accordion_blocks .toggles").removeClass("active");
        $(this).addClass("active");
        $(".footer_menu-_blocks.accordion_blocks .inners").slideUp(500);
        $(this)
          .siblings(".footer_menu-_blocks.accordion_blocks .inners")
          .slideDown(500);
      }
    });

    // Ensure that only the active inner is visible on load/resize
    $(".footer_menu-_blocks.accordion_blocks .toggles.active").siblings(".inners").show();
  } else {
    // Unbind click event and show all inners for larger screens
    $(".footer_menu-_blocks.accordion_blocks .toggles").off("click");
    $(".footer_menu-_blocks.accordion_blocks .inners").show();
  }
});


// Dropdown js
// document.querySelector(".custom-dropdown-selected").addEventListener("click", function () {
//   const options = document.querySelector(".custom-dropdown-options");
//   options.style.display = options.style.display === "block" ? "none" : "block";
// });

// document.querySelectorAll(".custom-dropdown-options li").forEach((option) => {
//   option.addEventListener("click", function () {
//     document.querySelector(".custom-dropdown-selected").textContent = this.textContent;
//     document.querySelector(".custom-dropdown-options").style.display = "none";
//     location.href = this.getAttribute("data-value"); // Redirect on selection
//   });
// });



// Custom Dropdown menu on Policies page
// document.addEventListener("DOMContentLoaded", function () {
//   const dropdownToggle = document.querySelector(".dropdown-toggle");
//   const dropdownMenu = document.querySelector(".dropdown-menu");
//   const dropdownWrap = document.querySelector(".content_dropdown_menu-wrap");

//   // Initialize with the active menu item (if any)
//   const activeItem = dropdownMenu.querySelector(".dropdown-item.selected");
//   if (activeItem) {
//     dropdownToggle.textContent = activeItem.textContent.trim();
//   }

//   // Toggle the dropdown menu on button click
//   dropdownToggle.addEventListener("click", function () {
//     dropdownWrap.classList.toggle("active");
//   });

//   // Close the dropdown if clicking outside
//   document.addEventListener("click", function (e) {
//     if (!dropdownWrap.contains(e.target)) {
//       dropdownWrap.classList.remove("active");
//     }
//   });

//   // Update dropdown-toggle text and active state when an item is clicked
//   dropdownMenu.addEventListener("click", function (e) {
//     const clickedItem = e.target.closest(".dropdown-item");
//     if (clickedItem) {
//       // Update the button text
//       dropdownToggle.textContent = clickedItem.textContent.trim();

//       // Remove the "selected" class from all items
//       dropdownMenu.querySelectorAll(".dropdown-item").forEach(item => {
//         item.classList.remove("selected");
//       });

//       // Add the "selected" class to the clicked item
//       clickedItem.classList.add("selected");

//       // Close the dropdown menu
//       dropdownWrap.classList.remove("active");
//     }
//   });
// });



// Final
// document.addEventListener("DOMContentLoaded", function () {
//   const dropdownToggle = document.querySelector(".dropdown-toggle");
//   const dropdownMenu = document.querySelector(".dropdown-menu");
//   const dropdownWrap = document.querySelector(".content_dropdown_menu-wrap");

//   // Initialize with the active menu item (if any)
//   const activeItem = dropdownMenu.querySelector(".dropdown-item.selected");
//   if (activeItem) {
//     dropdownToggle.textContent = activeItem.textContent.trim();
//   }

//   // Toggle the dropdown menu on button click
//   dropdownToggle.addEventListener("click", function (e) {
//     e.stopPropagation(); // Prevent propagation to avoid accidental close
//     dropdownWrap.classList.toggle("active");
//   });

//   // Close the dropdown if clicking outside
//   document.addEventListener("click", function (e) {
//     if (!dropdownWrap.contains(e.target)) {
//       dropdownWrap.classList.remove("active");
//     }
//   });

//   // Update dropdown-toggle text and active state when an item is clicked
//   dropdownMenu.addEventListener("click", function (e) {
//     const clickedItem = e.target.closest(".dropdown-item");
//     if (clickedItem) {
//       // Check if the clicked item is already selected
//       const isAlreadySelected = clickedItem.classList.contains("selected");

//       if (!isAlreadySelected) {
//         // Update the button text only if the item is not already selected
//         dropdownToggle.textContent = clickedItem.textContent.trim();

//         // Remove the "selected" class from all items
//         dropdownMenu.querySelectorAll(".dropdown-item").forEach(item => {
//           item.classList.remove("selected");
//         });

//         // Add the "selected" class to the clicked item
//         clickedItem.classList.add("selected");
//       }

//       // Close the dropdown menu
//       dropdownWrap.classList.remove("active");
//     }
//   });
// });

// removed 
document.addEventListener("DOMContentLoaded", function () {
  const dropdownToggle = document.querySelector(".dropdown-toggle");
  const dropdownMenu = document.querySelector(".dropdown-menu");
  const dropdownWrap = document.querySelector(".content_dropdown_menu-wrap");

  // Check if dropdownToggle exists and remove it if needed
  if (dropdownToggle) {
    const activeItem = dropdownMenu.querySelector(".dropdown-item.selected");

    // If no active item is found, remove the button
    if (!activeItem) {
      dropdownToggle.remove(); // Remove the button entirely
    } else {
      // Initialize the button text with the active item's content
      dropdownToggle.textContent = activeItem.textContent.trim();
    }
  }

  // If dropdownToggle was removed, skip the rest of the logic
  if (!dropdownToggle) return;

  // Toggle the dropdown menu on button click
  dropdownToggle.addEventListener("click", function (e) {
    e.stopPropagation(); // Prevent event propagation
    dropdownWrap.classList.toggle("active");
  });

  // Close the dropdown if clicking outside
  document.addEventListener("click", function (e) {
    if (!dropdownWrap.contains(e.target)) {
      dropdownWrap.classList.remove("active");
    }
  });

  // Update dropdown-toggle text and active state when an item is clicked
  dropdownMenu.addEventListener("click", function (e) {
    const clickedItem = e.target.closest(".dropdown-item");

    if (clickedItem) {
      const newText = clickedItem.textContent.trim();
      dropdownToggle.textContent = newText;

      // Remove the "selected" class from all items
      dropdownMenu.querySelectorAll(".dropdown-item").forEach(item => {
        item.classList.remove("selected");
      });

      // Add the "selected" class to the clicked item
      clickedItem.classList.add("selected");

      // Close the dropdown menu
      dropdownWrap.classList.remove("active");
    }
  });
});

